import { Navigate, useLocation } from "react-router-dom"
import "source/giving/donate/form/styles/donation-form.css"
import { AlertMessage } from "source/shared/components"
import { useSession } from "source/shared/hooks/useSession"
import ConfirmationLayout from "../../components/ConfirmationLayout"
import { PostDonateStatus } from "../form/components/PostDonateStatus"
import { dateStampStringToLocal } from "../form/utils/frequency"

export function DonationThankYou() {
  const {
    data: {
      attributes: { first_name },
    },
  } = useSession()

  const { state } = useLocation()

  if (!state) {
    console.debug(
      "[DonationForm] missing navigation state for thank you page, redirecting to form",
    )
    return <Navigate to="/giving/" replace />
  }

  const { date, recurring, awaitingVerification } = state

  function getMessage() {
    if (awaitingVerification && recurring) {
      return "Once your bank account is verified, your first recurring donation will be processed on the next scheduled date. We’ll email your receipt when it’s completed."
    } else if (awaitingVerification && !recurring) {
      return "Once your bank account is verified, we will process the donation and email your receipt."
    } else if (recurring) {
      return `Your recurring donation is scheduled ${date ? "to begin on " + dateStampStringToLocal(date) : ""}. We’ll email a receipt for your records.`
    } else {
      // standard one-time
      return "Your donation has been received, and we emailed a receipt for your records."
    }
  }

  return (
    <ConfirmationLayout>
      {awaitingVerification && (
        <AlertMessage type="warning" icon="general#exclamation-triangle">
          <div className="d-f fd-c g-4p">
            <strong>Your bank account needs verification</strong>
            <div>Follow the verification instructions in your email.</div>
          </div>
        </AlertMessage>
      )}
      <PostDonateStatus
        status={awaitingVerification ? "action-required" : "success"}
        heading={`Thank you, ${first_name}!`}
        message={getMessage()}
      />
    </ConfirmationLayout>
  )
}
